import React from 'react';
import { Link } from 'react-router-dom';
import './ArticleCard.css';

const ArticleCard: React.FC<ArticleCardProps> = ({ timestamp, title, link, eyecatch, tags }) => {
    const tagContent = tags.map((tag) =>
        <div key={tag} className="article-tag-text">{tag}</div>
    );

    return (
        <Link to={link}>
            <div className="article-card">
                <div className="article-image-space">
                    <img  className="article-image" src={eyecatch}></img>
                </div>
                <div className="article-detail">
                    <div className="article-timestamp-space">
                        <div className="article-timestamp-text">{timestamp}</div>
                    </div>
                    <div className="article-title-space">
                        <div className="article-title-text">{title}</div>
                    </div>
                    <div className="article-tag-space">
                        {tagContent}
                    </div>
                </div>
            </div>
        </Link>
    );
}

type ArticleCardProps = {
    timestamp: string,
    title: string,
    link: string,
    eyecatch: string,
    tags: Array<string>,
};

export default ArticleCard;